var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-row"},[_c('a',{attrs:{"tabindex":"0","href":"/privacy"}},[_vm._v("PRIVACY")]),_vm._v(" | "),_c('a',{attrs:{"tabindex":"0","href":"/legal"}},[_vm._v("LEGAL")]),_vm._v(" "),_c('br'),_c('br'),_vm._v("\n   COPYRIGHT © "+_vm._s(_vm.copyrightYear)+" COMPANY INC.\n   "),_c('br'),_vm._v("\n   ALL RIGHTS RESERVED.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bfe7012","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = t7h/
// module chunks = 1